module.exports = __webpack_public_path__ + "static/priya-433d02d618266a92049510c88ec021c0.jpg";